(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ControlListController', ControlListController);

    ControlListController.$inject = ['$rootScope','$http', 'NotificationService', 'ControlListService', 'FoundationApi', 'Upload', 'ngTableParams', 'LangService'];

  function ControlListController($rootScope,$http, NotificationService, ControlListService, FoundationApi, Upload, ngTableParams, LangService) {
    var vm = this;
    vm.labelsPage = ''
    vm.phoneMask = "(99) 9?99999999";
    vm.documentMask = "999.999.999-99";
    vm.dataMask = "99/99/9999";
    vm.newDocument = "";
    vm.document = "";
    vm.status_filter = "";
    vm.first_period_filter = moment().startOf("month").format("DD/MM/YYYY");
    vm.end_period_filter = moment().endOf("month").format("DD/MM/YYYY");
    vm.newName = '';
    vm.newPhone = '';
    vm.newDocument = '';
    vm.newList = {};
    vm.newListName = '';
    vm.Person = [];

    getList()
    filterPersons()

    function getList() 
    {
      ControlListService
        .getList()
        .$promise
        .then(function(data) {
            vm.allList = data;
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.error_get);
        });
    }

    vm.addPerson = () => {
      FoundationApi.publish('registerPerson', 'open')
    }

    vm.getNewList = () => {
      vm.newListJson = JSON.parse(vm.newList)
      vm.newListType = vm.newListJson.type
      vm.newListName = vm.newListJson.name
      vm.newListID = vm.newListJson.id
    }

    vm.clearAddNewPerson = () => {
      vm.newName = ''
      vm.newPhone = ''
      vm.newDocument = ''
      vm.newList = ''
      vm.newListType = '4'
      vm.newListName = ''
    }

    vm.addNewPerson = () => { 

      if (!vm.newListType || vm.newListType == '4') {
        return NotificationService.warningHandler(
          {},
          vm.labelsPage.requiredSelectedList ? vm.labelsPage.requiredSelectedList : 'Favor selecionar uma lista!'
        );
      }
      if ((!vm.newName || vm.newName.trim() === '') && vm.newListType == 2) {
        return NotificationService.warningHandler(
          {},
          vm.labelsPage.requiredNameField ? vm.labelsPage.requiredNameField : 'Favor preencher o campo nome!'
        );
      }
      if ((!vm.newPhone || vm.newPhone.trim() === '') && (vm.newListType == 1 || vm.newListType == 2)) {
        return NotificationService.warningHandler(
          {},
          vm.labelsPage.requiredPhoneField ? vm.labelsPage.requiredPhoneField : 'Favor preencher o campo telefone!'
        );
      }
      if ((!vm.newDocument || vm.newDocument.length != 11) && (vm.newListType == 3)) {
        return NotificationService.warningHandler(
          {},
          vm.labelsPage.invalidDocument ? vm.labelsPage.invalidDocument : 'CPF inválido!'
        );
      }
      ControlListService
        .save({
          name: vm.newName, 
          phone: vm.newPhone, 
          document: vm.newDocument,
          list: vm.newListID
        }).$promise
        .then(function (data) {
          vm.clearAddNewPerson()
          FoundationApi.publish('registerPerson', 'close')
          filterPersons()
          NotificationService.successHandler(data, vm.labelsPage.contactBlockSuccess);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.contactBlockFail);
        })
    }


    function filterPersons() {
      vm.Person = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          let filters = {
            page: params.url().page,
            phone: vm.phone,
            document: vm.document,
            status: vm.status_filter,
            first_period: vm.first_period_filter,
            end_period: vm.end_period_filter,
            list: vm.list_filter
          }
          ControlListService
            .getPerson(filters)
            .$promise
            .then(function (data) {
              if (data) {
                $defer.resolve(angular.copy(data.controlList.slice((params.page() - 1) * params.count(), params.page() * params.count())))
                params.total(angular.copy(data.controlList.length));
                vm.Total = (angular.copy(data.controlList.length));
                vm.PersonAll = (angular.copy(data.controlList));
              } else {
                NotificationService.errorHandler(data, vm.labelsPage.noDataFound);
              }
            }).catch(function (data) {
              NotificationService.errorHandler(data, vm.labelsPage.failGetData);
            });
        }
      })
    }

    vm.findPersons = () => {
      filterPersons();
    }

    vm.removePerson = (Person) => {
      vm.PersonDelete = Person
      FoundationApi.publish('removeModal', 'open')
    }

    vm.removePersonId = (Person) => {
      ControlListService
        .removePersonId(Person)
        .$promise
        .then(function (data) {
          FoundationApi.publish('removeModal', 'close')
          filterPersons()
          NotificationService.successHandler(data, vm.labelsPage.contactReleaseSuccess);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.contactReleaseFail);
        })
    }

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    LangService
      .getPageLabels({ 'page': 'menu.master.controlList' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });


    //IMPORT FUNCTIONS

    vm.import = function () {
      FoundationApi.publish('importModal', 'open');
    }

    window.upload_file = upload_file;

    vm.file_explorer = file_explorer;


    var fileobj;

    function upload_file(e) {
      e.preventDefault();
      fileobj = e.dataTransfer.files[0];
      validateFileUpload(fileobj);
    }


    function file_explorer() {
      document.getElementById('selectfile').click();
      document.getElementById('selectfile').onchange = function () {
        fileobj = document.getElementById('selectfile').files[0];
        validateFileUpload(fileobj);
      };
    }

    function validateFileUpload(file_obj) {
      vm.uploadedFile = null;
      if (file_obj != undefined) {
        if (file_obj.type !== 'text/csv' && file_obj.type !== 'application/vnd.ms-excel') {
          NotificationService.errorHandler(file_obj, vm.labelsPage.noCsvFile)
        } else {
          vm.uploadedFile = file_obj;
          NotificationService.successHandler(file_obj, vm.labelsPage.successImportFile)
        }
      } else {
        NotificationService.errorHandler(file_obj, vm.labelsPage.failImportFile)
      }
    }

    vm.saveUploadedFile = () => {
      Upload.upload({
        url: frontUrl + '/control-list/uploadFile',
        file: vm.uploadedFile
      })
      .then(function (response) {
        vm.controlListImport = response.data.updated
        let message = vm.labelsPage.success
          .replace('{1}', response.data.inserts)
          .replace('{2}', response.data.exists);
          vm.uploadedFile = ""
          filterPersons()
          FoundationApi.publish('importModal', 'close');

        NotificationService.successHandler(response,  message, 10000);
        vm.uploadedFile = null;
        FoundationApi.publish('importModal', 'close');
      })
      .catch(function(response) {
        NotificationService.errorHandler(response, vm.labelsPage.error)
      })
    }

    vm.deleteAll = function(Person) 
    {
      FoundationApi.publish('deleteAll', 'open');
    }

    vm.delete = (Person) => {
      ControlListService
        .removePersonAll(vm.PersonAll)
        .$promise
        .then(function (data) {
          FoundationApi.publish('deleteAll', 'close')
          filterPersons()
          NotificationService.successHandler(data, vm.labelsPage.contactReleaseSuccess);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, vm.labelsPage.contactReleaseFail);
        })
    }
  }
})();
